import api from './api';

export const getCourses = (page, searchTerm) => {
  return api.get('admin/education/courses', { params: { page, searchTerm } });
};

export const getCourseById = id => {
  return api.get(`admin/education/courses/${id}`);
};

export const getLessonById = id => {
  return api.get(`admin/education/lessons/${id}`);
};

export const getSpecialClasses = (page, limit, searchTerm) => {
  return api.get('admin/education/lessons-unique', { params: { page, limit, searchTerm } });
};

export const createCourse = data => {
  return api.post(`admin/education/create-course`, { ...data });
};

export const createModule = (courseId, moduleName) => {
  return api.post(`admin/education/create-module`, { courseId, name: moduleName });
};

export const createLesson = data => {
  return api.post(`admin/education/create-lesson`, { ...data });
};

export const createSpecialClass = data => {
  return api.post(`admin/education/create-special-class`, { ...data });
};

export const updateCourse = (courseId, data) => {
  return api.put(`admin/education/course/${courseId}`, { ...data });
};

export const updateModule = (moduleId, name) => {
  return api.put(`admin/education/module/${moduleId}`, { name });
};

export const updateLesson = (lessonId, data) => {
  return api.put(`admin/education/lesson/${lessonId}`, { ...data });
};

export const updateSpecialClass = (id, data) => {
  return api.put(`admin/education/special-class/${id}`, { ...data });
};

export const deleteSpecialClass = id => {
  return api.delete(`admin/education/special-class/${id}`);
};

export const deleteCourse = id => {
  return api.delete(`admin/education/course/${id}`);
};

export const deleteModule = id => {
  return api.delete(`admin/education/module/${id}`);
};

export const deleteLesson = id => {
  return api.delete(`admin/education/lesson/${id}`);
};
